/* Setting Images */
import inland_hillside from "./settings/inland_hillside.jpg";
import inland_valley from "./settings/inland_valley.jpg";
import next_to_coast_hillside from "./settings/next_to_coast_hillside.jpg";
import next_to_coast_low_lying from "./settings/next_to_coast_low_lying.jpg";
import inland_other from "./settings/inland_other.jpg";
import { listOfAreas } from "./listOfAreas.js";
/* Roof Types */

import hip from "./assets/hip.jpg";
import pyramid_hip from "./assets/pyramid_hip.jpg";
import hip_and_valley from "./assets/hip_and_valley.jpg";
import cross_hipped from "./assets/cross_hipped.jpg";
import intersecting_overlaid_hip from "./assets/intersecting_overlaid_hip.jpg";
import open_gable from "./assets/open_gable.jpg";
import box_gable from "./assets/box_gable.jpg";
import dutch_gable from "./assets/dutch_gable.jpg";
import flat_concrete_slab from "./assets/flat_concrete.jpg";
import flat_timber_frame from "./assets/flat_concrete.jpg";
import shed from "./assets/shed.jpg";
import mansard from "./assets/mansard.jpg";
import gambrel from "./assets/gambrel.jpg";
import combination from "./assets/combination.jpg";
import m_shaped from "./assets/m_shaped.jpg";
import hexagonal_gazebo from "./assets/hexagonal_gazebo.jpg";
import saltbox from "./assets/saltbox.jpg";
import butterfly from "./assets/butterfly.jpg";

/* Roof Covering Material  */
import concreteImage from "./assets/Concrete.jpg";
import galvalume_sheets from "./assets/galvanized_galvalume_sheets.jpg";
import asphalt_shingles from "./assets/asphalt_shingles.jpg";
import metal_shingles from "./assets/metal_shingles.jpg";
import wooden_shingles from "./assets/wooden_shingles.jpg";
import clay_concrete_shingles_tiles from "./assets/clay_concrete_shingles_tiles.jpg";
import bituminous_felt from "./assets/bituminous_felt.jpg";
import concrete_roof_with_bituminous_felt from "./assets/concrete_roof_with_bituminous_felt.jpg";

/** Hurricane Shutters */
import colonial from "./assets/colonial.png";
import bahama from "./assets/bahama.png";
import automatic_roll_down from "./assets/roll-up.png";
import accordion from "./assets/accordion.png";

/* Porch / Veranda */
import non_concrete_porch_veranda_roof_detached from "./assets/non_concrete_porch_veranda_roof_detached.jpg";
import concrete_porch_veranda_roof_detached from "./assets/concrete_porch_veranda_roof_detached.jpg";
import non_concrete_porch_veranda_roof_attached from "./assets/non_concrete_porch_veranda_roof_attached.jpg";
import concrete_porch_veranda_roof_attached from "./assets/concrete_porch_veranda_roof_attached.jpg";
import deck_no_roof from "./assets/deck_no_roof.jpg";

/* Garage Porch */
import fully_enclosed_and_detached_from_main_house_with_independent_roof from "./assets/fully_enclosed_and_detached_from_main_house_with_independent_roof.jpg";
import fully_enclosed_and_attached_to_main_house_with_connected_roof_system from "./assets/fully_enclosed_and_attached_to_main_house_with_connected_roof_system.jpg";
import fully_enclosed_and_attached_to_main_house_with_independent_roof from "./assets/fully_enclosed_and_attached_to_main_house_with_independent_roof.jpg";
import open_sided_and_detached_from_main_house_with_independent_roof from "./assets/open_sided_and_detached_from_main_house_with_independent_roof.jpg";
import open_sided_and_attached_to_main_house_with_independent_roof from "./assets/open_sided_and_attached_to_main_house_with_independent_roof.jpg";
import open_sided_and_attached_to_main_house_with_connected_concrete_roof_system from "./assets/open_sided_and_attached_to_main_house_with_connected_concrete_roof_system.jpg";
import open_sided_and_attached_to_main_house_with_connected_non_concrete_roof_system from "./assets/open_sided_and_attached_to_main_house_with_connected_non_concrete_roof_system.jpg";

export const schema = {
  user_info: {
    step: 1,
    fieldType: "group_field",
    tagId: "user_info",
    titleText: "General Information",
    wrapperStyle: {
      class: "col s12",
      style: {
        background: "",
        marginTop: "",
      },
    },
    cardStyle: {
      class: "",
      style: {
        background: "",
      },
    },
    validations: {},
  },
  user_label: {
    step: 1,
    fieldType: "label_field",
    type: "desc",
    groupTag: "user_info",
    label: "Full Name*",
    wrapperStyle: {
      class: "col s12 wm-label",
    },
    validations: {},
  },
  name: {
    step: 1,
    fieldType: "input_field",
    type: "text",
    groupTag: "user_info",
    // label: "Select the most suitable options.",
    wrapperStyle: {
      class: "col s12 input-field",
    },
    validations: {},
  },
  email_label: {
    step: 1,
    fieldType: "label_field",
    type: "desc",
    groupTag: "user_info",
    label: "Email*",
    wrapperStyle: {
      class: "col s12 wm-label",
    },
    validations: {
      required: {
        message: "Email is required",
      },
    },
  },
  email: {
    step: 1,
    fieldType: "input_field",
    type: "email",
    groupTag: "user_info",
    // label: "Select the most suitable options.",
    wrapperStyle: {
      class: "col s12 input-field",
    },
    validations: {
      required: {
        message: "Email is required",
      },
      email: {
        message: "Email is not valid",
      }
    },
  },
  address_group: {
    step: 1,
    fieldType: "group_field",
    tagId: "address_group",
    wrapperStyle: {
      class: "col s12",
      style: {
        background: "",
        marginTop: "",
      },
    },
    cardStyle: {
      class: "",
      style: {
        background: "",
      },
    },
    validations: {},
  },
  address_community: {
    step: 1,
    fieldType: "autocomplete",
    type: "autocomplete",
    groupTag: "address_group",
    label: "Address/Community",
    showLabel: true,
    helperText: "Start typing your address/community and select the most appropriate option from the drop-down menu that appears.",
    placeholder: "0",
    browserDefault: true,
    isMultiple: false,
    value: "",
    wrapperStyle: {
      class: "col s12 input-field",
    },
    fieldStyle: {
      class: "white",
    },
    options: { ...listOfAreas },
    validations: {},
    option: [
      {
        text: "Click to select",
        value: "",
        default: true,
      },
      {
        text: "Anse La Raye",
        value: "Anse La Raye",
      },
      {
        text: "Canaries",
        value: "Canaries",
      },
      {
        text: "Castries",
        value: "Castries",
      },
      {
        text: "Chousiel",
        value: "Chousiel",
      },
      {
        text: "Dennery",
        value: "Dennery",
      },
      {
        text: "Laborie",
        value: "Laborie",
      },
      {
        text: "Gros Islet",
        value: "Gros Islet",
      },
      {
        text: "Micoud",
        value: "Micoud",
      },
      {
        text: "Vieux Fort",
        value: "Vieux Fort",
      },
      {
        text: "Rodney Bay",
        value: "Rodney Bay",
      },
      {
        text: "Soufriere",
        value: "Soufriere",
      },
    ],
  },

  character_info: {
    step: 1,
    fieldType: "group_field",
    tagId: "character_info",
    wrapperStyle: {
      class: "col s12",
      style: {
        background: "",
        marginTop: "",
      },
    },
    cardStyle: {
      class: "",
      style: {
        background: "",
      },
    },
    validations: {},
  },
  /* 	label_0: {
    step: 1,
    fieldType: 'label_field',
    type: 'input-label',
    groupTag: 'character_info',
    label: 'Land Characteristics',
    fieldStyle: {
        class: '',
        style: { 	}
    },
    validations: {}
  }, */

  land_characteristics: {
    step: 1,
    fieldType: "select_field",
    type: "select_field",
    groupTag: "character_info",
    label: "Setting",
    titleText: "Land characteristics",
    showLabel: true,
    helperText: "Please select the setting that best describes where you live.",
    placeholder: "0",
    browserDefault: false,
    selectGuide: true,
    isMultiple: true,
    value: "",
    wrapperStyle: {
      class: "col s12 input-field",
    },
    fieldStyle: {
      class: "land-characteristics-input white",
    },
    validations: {},
    options: [
      {
        text: "Click to select",
        value: "",
        default: true,
      },
      {
        text: "Inland - hillside",
        value: "inland_hillside",
        image: inland_hillside,
      },
      {
        text: "Inland - valley",
        value: "inland_valley",
        image: inland_valley,
      },
      {
        text: "Inland - other",
        value: "inland_other",
        image: inland_other,
      },
      {
        text: "Next to coast - hillside",
        value: "next_to_coast_hillside",
        image: next_to_coast_hillside,
      },
      {
        text: "Next to coast - low-lying",
        value: "next_to_coast_low_lying",
        image: next_to_coast_low_lying,
      },

      /* 		{
        text: 'Plain',
        value: 'plain'
    },
    {
        text: 'Valley',
        value: 'valley'
    },
    {
      text: 'Hillside',
      value: 'hillside'
    },
    {
      text: 'Low-lying coastal area',
      value: 'Low-lying coastal area'
    } */
    ],
  },
  slope_of_lot: {
    step: 1,
    fieldType: "select_field",
    type: "select_field",
    browserDefault: true,
    showHelperText: false,
    groupTag: "character_info",
    isMultiple: false,
    label: "Slope of house lot",
    showLabel: true,
    helperText: "",
    placeholder: "",
    value: "",
    options: [
      {
        text: "Click to select",
        value: "",
        default: true,
      },
      {
        text: "Flat (a ball will remain almost stationary)",
        value: "flat",
      },
      {
        text: "Gentle slope (a ball will roll slowly down the slope)",
        value: "gentle slope",
      },
      {
        text: "Steep slope (a ball will roll quickly down the slope) ",
        value: "steep slope",
      },
    ],
    wrapperStyle: {
      class: "col s12 input-field",
    },
    fieldStyle: {
      class: "",
    },
    validations: {},
  },

  label_3: {
    step: 1,
    fieldType: "label_field",
    type: "input-label",
    groupTag: "character_info",
    label: "Size of house lot (approx. square footage)",
    fieldStyle: {
      class: "col s12 sized-label",
    },
    validations: {},
  },
  size_of_house_lot: {
    step: 1,
    fieldType: "input_field",
    type: "number",
    groupTag: "character_info",
    label: "Size of house lot(Acres)",
    showLabel: false,
    /* 	helperText: 'Approx. size of house lot (square footage)', */
    placeholder: "0",
    value: "",
    wrapperStyle: {
      class: "col s12",
    },
    fieldStyle: {
      class: "house-info-input",
    },
    validations: {},
  },

  house_info_group: {
    step: 1,
    fieldType: "group_field",
    tagId: "house_info",
    wrapperStyle: {
      class: "col s12 ",
      style: {
        /* 			background: '#536dfe',
            marginTop: '', */
      },
    },
    cardStyle: {
      class: "",
      style: {
        /* 	background: '#536dfe' */
      },
    },
    validations: {},
  },

  /* 	label_1: {
      step: 1,
      fieldType: 'label_field',
      type: 'input-label',
      groupTag: 'house_info',
      label: 'Distance to coast(Km)',
      fieldStyle: {
          class: 'col s12 distance-label'
      },
      validations: {}
  },
 */
  distance_to_coast: {
    step: 1,
    fieldType: "select_field",
    type: "number",
    groupTag: "house_info",
    label: "Distance to Coast",
    showLabel: true,
    mapGuide: true,
    descriptionText: `Use Google Maps to estimate the distance from your home to the coast.`,
    helperText: "How close do you live to the coast?",
    placeholder: "0",
    browserDefault: true,
    isMultiple: false,

    value: "",
    wrapperStyle: {
      class: "col s12 input-field",
    },
    fieldStyle: {
      class: "house-info-input white",
    },
    validations: {},
    options: [
      {
        text: "Click to select",
        value: "",
        default: true,
      },
      {
        text: "Directly next to coast (less than 100m away)",
        value: "directly",
      },
      {
        text: "Nearby (more than 100m away but less than 500m/0.5km/0.3miles away)",
        value: "nearby",
      },
      {
        text: "Distant (more than 500m/0.5km/0.3miles away) ",
        value: "distant",
      },
      {
        text: "Use google maps",
        value: "Map Estimation",
      },
    ],
  },
  /* 	label_2: {
      step: 1,
      fieldType: 'label_field',
      type: 'input-label',
      groupTag: 'house_info',
      label: 'Distance to River(Km)',
      fieldStyle: {
          class: 'col s12 input-field'
      },
      validations: {}
  }, */
  distance_to_river: {
    step: 1,
    fieldType: "select_field",
    type: "select_field",
    browserDefault: true,
    groupTag: "house_info",
    mapGuide: true,
    isMultiple: false,
    label: "Distance to River",
    descriptionText: `Use Google Maps to estimate the distance from your home to the nearest river. `,
    showLabel: true,
    helperText: "How close do you live to the nearest river?",
    placeholder: "",
    value: "",
    options: [
      {
        text: "Click to select",
        value: "",
        default: true,
      },
      {
        text: "Directly next to river (less than 100m away)",
        value: "directly",
      },
      {
        text: "Nearby (more than 100m away but less than 500m/0.5km/0.3miles away)",
        value: "nearby",
      },
      {
        text: "Distant (more than 500m/0.5km/0.3miles away)",
        value: "distant",
      },
    ],
    wrapperStyle: {
      class: "col s12 input-field",
    },
    fieldStyle: {
      class: "house-info-input",
    },
    validations: {},
  },

  home_characteristics_group: {
    step: 1,
    fieldType: "group_field",
    tagId: "home_characteristics",
    titleText: "House Characteristics",
    wrapperStyle: {
      class: "col s12 home-characteristics",
      style: {
        marginTop: "",
      },
    },
    cardStyle: {
      class: "",
    },
    validations: {},
  },
  hc_label_1: {
    step: 1,
    fieldType: "label_field",
    type: "desc",
    groupTag: "home_characteristics",
    label: "Age of structure (years)",
    wrapperStyle: {
      class: "col s8 hm-label ",
    },
    validations: {},
  },
  house_age: {
    step: 1,
    fieldType: "input_field",
    type: "number",
    groupTag: "home_characteristics",
    label: "",
    showLabel: false,
    helperText: "",
    placeholder: "0",
    value: "",
    showHelperText: false,
    wrapperStyle: {
      class: "col s4 hm-input-wrapper",
    },
    fieldStyle: {
      class: "hm-input",
    },
    validations: {},
  },
  hc_label_2: {
    step: 1,
    fieldType: "label_field",
    type: "desc",
    groupTag: "home_characteristics",
    label: "Size (approximate square footage)",
    wrapperStyle: {
      class: "col s8 hm-label ",
    },
    validations: {},
  },
  house_size: {
    step: 1,
    fieldType: "input_field",
    type: "number",
    groupTag: "home_characteristics",
    label: "",
    showLabel: false,
    helperText: "",
    showHelperText: false,
    placeholder: "0",
    value: "",
    wrapperStyle: {
      class: "col s4 hm-input-wrapper",
    },
    fieldStyle: {
      class: "hm-input",
    },
    validations: {},
  },
  hc_label_3: {
    step: 1,
    fieldType: "label_field",
    type: "desc",
    groupTag: "home_characteristics",
    label: "Number of floors/levels",
    wrapperStyle: {
      class: "col s8 hm-label ",
    },
    validations: {},
  },
  number_of_stories: {
    step: 1,
    fieldType: "input_field",
    type: "number",
    groupTag: "home_characteristics",
    label: "",
    showLabel: false,
    helperText: "",
    showHelperText: false,
    placeholder: "0",
    value: "",
    wrapperStyle: {
      class: "col s4 hm-input-wrapper",
    },
    fieldStyle: {
      class: "hm-input",
    },
    validations: {},
  },
  wall_material_group: {
    step: 1,
    fieldType: "group_field",
    tagId: "wall_material",
    titleText: "Exterior Wall Material",
    wrapperStyle: {
      class: "col s12 wall-material",
      style: {
        marginTop: "",
      },
    },
    cardStyle: {
      class: "",
    },
    validations: {},
  },
  wm_label_1: {
    step: 1,
    fieldType: "label_field",
    type: "desc",
    groupTag: "wall_material",
    label: "Select the most suitable options.",
    wrapperStyle: {
      class: "col s12 wm-label",
    },
    validations: {},
  },
  wall_material_option: {
    step: 1,
    fieldType: "select_field",
    // type: 'number',
    groupTag: "wall_material",
    label: "",
    //	disableIf: 'other',
    isMultiple: true,
    showLabel: false,
    selectGuide: false,
    helperText: "",
    browserDefault: false,
    showHelperText: false,
    value: null, // Sets default value
    // placeholder: '0',
    wrapperStyle: {
      class: "col s12 wm-select-wrapper input-field",
    },
    fieldStyle: {
      class: "wm-select",
    },
    options: [
      {
        text: "Click to select",
        value: null,
        default: true,
      },
      {
        text: "Masonry concrete",
        value: "masonry_concrete",
      },
      {
        text: "Wood",
        value: "wood",
      },
      {
        text: "Stone",
        value: "stone",
      },
      {
        text: "Cement board",
        value: "cement_board",
      },
      {
        text: "Metal (e.g. galvanize, sheet metal)",
        value: "metal",
      },
      {
        text: "Other (enter data)",
        value: "other",
      },
    ],
    validations: {},
  },
  other_option_wall_material: {
    step: 1,
    type: "text",
    groupTag: "wall_material",
    fieldType: "input_field",
    condition: {
      key: "wall_material_option",
      value: "other",
      action: "hide",
    },
    validations: {},
  },
  roof_type_group: {
    step: 1,
    fieldType: "group_field",
    tagId: "roof_type_group",
    titleText: "Roof Type",
    wrapperStyle: {
      class: "col s12 roof-type",
      style: {
        marginTop: "",
      },
    },
    cardStyle: {
      class: "",
    },
    validations: {},
  },
  roof_type: {
    step: 1,
    fieldType: "select_field",
    type: "select_field",
    titleText: "Root type",
    groupTag: "roof_type_group",
    label: "Roof Type",
    label: "",
    showLabel: true,
    helperText: "Some homes have a combination of roof types - select all options that apply.",
    placeholder: "0",
    browserDefault: false,
    displayImage: false,
    selectGuide: true,
    isMultiple: true,
    value: "",
    wrapperStyle: {
      class: "col s12 input-field",
    },
    validations: {},
    options: [
      {
        text: "Hip",
        value: "Hip",
        image: hip,
        styles: {
          backgroundPosition: "-696px -20px",
        },
      },
      {
        text: "Pyramid Hip",
        value: "Pyramid Hip",
        image: pyramid_hip,
        styles: {
          backgroundPosition: "-698px -502px",
        },
      },
      {
        text: "Hip and Valley",
        value: "Hip and Valley",
        image: hip_and_valley,
        styles: {
          backgroundPosition: "-14px -186px",
        },
      },
      {
        text: "Cross Hipped",
        value: "Cross Hipped",
        image: cross_hipped,
        styles: {
          backgroundPosition: "-695px -360px",
        },
      },
      {
        text: "Intersecting/Overlaid Hip",
        value: "Intersecting/Overlaid Hip",
        image: intersecting_overlaid_hip,
        styles: {
          backgroundPosition: "-695px -199px",
        },
      },
      {
        text: "Open Gable",
        value: "Open Gable",
        image: open_gable,
        styles: {
          backgroundPosition: "-195px -30px",
        },
      },
      {
        text: "Box Gable",
        value: "Box Gable",
        image: box_gable,
        styles: {
          backgroundPosition: "-345px -35px",
        },
      },
      {
        text: "Dutch Gable",
        value: "Dutch Gable",
        image: dutch_gable,
        styles: {
          backgroundPosition: "-8px  -353px",
        },
      },
      {
        text: "Flat (Concrete slab)",
        value: "Flat (Concrete slab)",
        image: flat_concrete_slab,
        styles: {
          backgroundPosition: "-510px -334px",
        },
      },
      {
        text: "Flat (timber frame) ",
        value: "Flat (timber frame) ",
        image: flat_timber_frame,
        styles: {
          backgroundPosition: "-510px -334px",
        },
      },
      {
        text: "Shed",
        value: "Shed",
        image: shed,
        styles: {
          backgroundPosition: "-337px -504px",
        },
      },
      {
        text: "Mansard",
        value: "Mansard",
        image: mansard,
        styles: {
          backgroundPosition: "-355px -180px",
        },
      },
      {
        text: "Gambrel",
        value: "Gambrel",
        image: gambrel,
        styles: {
          backgroundPosition: "-184px	-186px",
        },
      },
      {
        text: "Combination",
        value: "Combination",
        image: combination,
        styles: {
          backgroundPosition: "-522px	-499px",
        },
      },
      {
        text: "M Shaped",
        value: "M Shaped",
        image: m_shaped,
        styles: {
          backgroundPosition: "-12px	-499px",
        },
      },
      {
        text: "Hexagonal Gazebo",
        value: "Hexagonal Gazebo",
        image: hexagonal_gazebo,
        styles: {
          backgroundPosition: "-180px	-340px",
        },
      },
      {
        text: "Saltbox",
        value: "Saltbox",
        image: saltbox,
        styles: {
          backgroundPosition: "-182px	-504px",
        },
      },
      {
        text: "Butterfly",
        value: "Butterfly",
        image: butterfly,
        styles: {
          backgroundPosition: "-513px	-174px",
        },
      },
    ],
  },
  /* 	roof_type: {
      step: 1,
      fieldType: 'custom_select_field',
      titleText: 'Roof Type',
      label: 'Select the most suitable option',
      value: null,
      wrapperStyle: {
          class: 'col s12',
          style: {
              background: '#5374F8'
          }
      },
      cardStyle: {
          class: 'z-depth-0 white-text',
          style: {
              background: '#5374F8'
          }
      },
      options: [{
              text: 'Click to select',
              value: null,
              default: true,
          },
          {
              localImage: imageThree,
              value: 'plain',
              text: 'plain'
          },
          {
              localImage: imageFour,
              value: 'valley',
              text: 'Valley',
          }
      ],
      selectorName: 'Roofing Options',
      selectorGridStyle: {
          grid: 'col s6'
      },
      validations: {}
  }, */
  roof_material_group: {
    step: 1,
    fieldType: "group_field",
    tagId: "roof_material",
    titleText: "Roof Covering Material",
    wrapperStyle: {
      class: "col s12 roof-material",
      style: {
        marginTop: "",
      },
    },
    cardStyle: {
      class: "",
    },
    validations: {},
  },
  rf_label_1: {
    step: 1,
    fieldType: "label_field",
    type: "desc",
    groupTag: "roof_material",
    label: "Select the most suitable option",
    wrapperStyle: {
      class: "col s12 wm-label",
    },
    validations: {},
  },
  rf_material_option: {
    step: 1,
    fieldType: "select_field",
    // type: 'number',
    titleText: "Roof Covering Material",
    groupTag: "roof_material",
    label: "",
    isMultiple: true,
    showLabel: false,
    selectGuide: true,
    helperText: "",
    browserDefault: false,
    showHelperText: false,
    value: null, // Sets default value
    // placeholder: '0',
    wrapperStyle: {
      class: "col s12 wm-select-wrapper input-field",
    },
    fieldStyle: {
      class: "wm-select",
    },
    options: [
      {
        text: "Click to select",
        value: null,
        default: true,
      },
      {
        text: "Concrete screed (the finishing material on a concrete roof structure)",
        value: "concrete",
        image: concreteImage,
      },
      {
        text: "Concrete roof with bituminous felt",
        value: "concrete_bituminous_felt",
        image: concrete_roof_with_bituminous_felt,
      },
      {
        text: "Galvanized / galvalume sheets",
        value: "galvanized_galvalume_sheets",
        image: galvalume_sheets,
      },
      {
        text: "Asphalt shingles",
        value: "asphalt_shingles",
        image: asphalt_shingles,
      },
      {
        text: "Metal shingles",
        value: "metal_shingles",
        image: metal_shingles,
      },
      {
        text: "Wooden shingles",
        value: "wooden_shingles",
        image: wooden_shingles,
      },
      {
        text: "Clay tiles - Tiles/shingles (other material)",
        value: "clay_concrete_shingles_tiles",
        image: clay_concrete_shingles_tiles,
      },
      {
        text: "Bituminous felt",
        value: "bituminous_felt",
        image: bituminous_felt,
      },
      {
        text: "Other (enter data)",
        value: "other",
      },
    ],
    validations: {},
  },
  other_option_roof_material: {
    step: 1,
    type: "text",
    groupTag: "roof_material",
    fieldType: "input_field",
    placeholder: "Enter other value here",
    condition: {
      key: "rf_material_option",
      value: "other",
      action: "hide",
    },
    validations: {},
  },
  window_type_group: {
    step: 1,
    fieldType: "group_field",
    tagId: "window_type",
    titleText: "Window Material",
    wrapperStyle: {
      class: "col s12 wall-material",
      style: {
        marginTop: "",
      },
    },
    cardStyle: {
      class: "",
    },
    validations: {},
  },
  rf_label_1: {
    step: 1,
    fieldType: "label_field",
    type: "desc",
    groupTag: "window_type",
    label: "Select all relevant options.",
    wrapperStyle: {
      class: "col s12 wm-label",
    },
    validations: {},
  },
  window_type_option: {
    step: 1,
    fieldType: "select_field",
    // type: 'number',
    groupTag: "window_type",
    label: "",
    isMultiple: true,
    showLabel: false,
    titleText: "Window Type",
    helperText: "",
    browserDefault: false,
    showHelperText: false,
    value: null, // Sets default value
    // placeholder: '0',
    wrapperStyle: {
      class: "col s12 wm-select-wrapper input-field",
    },
    fieldStyle: {
      class: "wm-select",
    },
    options: [
      {
        text: "Click to select",
        value: null,
        default: true,
      },
      {
        text: "Glass (regular)",
        value: "glass",
      },
      {
        text: "Glass (impact resistant)",
        value: "glass_impact_resistant",
      },
      {
        text: "Metal (e.g. aluminum louvers)",
        value: "metal ",
      },
      {
        text: "Wooden",
        value: "wooden",
      },
      {
        text: "Other (enter data)",
        value: "other",
      },
    ],
    validations: {},
  },
  other_window_type_option: {
    step: 1,
    type: "text",
    groupTag: "window_type",
    fieldType: "input_field",
    placeholder: "Enter other value here",
    condition: {
      key: "window_type_option",
      value: "other",
      action: "hide",
    },
    validations: {},
  },
  shutters_type_group: {
    step: 1,
    fieldType: "group_field",
    tagId: "shutters_type_group",
    titleText: "Hurricane Shutters",
    wrapperStyle: {
      class: "col s12 wall-material",
      style: {
        marginTop: "",
      },
    },
    cardStyle: {
      class: "",
    },
    validations: {},
  },
  hurricane_shutters_q: {
    step: 1,
    fieldType: "select_field",
    groupTag: "shutters_type_group",
    showLabel: true,
    helperText: "Do you have hurricane shutters?",
    placeholder: "0",
    browserDefault: true,
    isMultiple: false,

    value: "",
    wrapperStyle: {
      class: "col s12 input-field",
    },
    fieldStyle: {
      class: "house-info-input white",
    },
    validations: {},
    options: [
      {
        text: "Click to select",
        value: "",
        default: true,
      },
      {
        text: "Yes - for all windows and doors",
        value: "yes_all_windows_doors",
      },
      {
        text: "Yes - for all windows, but no doors",
        value: "yes_all_windows_only",
      },
      {
        text: "Yes - for some windows and some doors",
        value: "yes_some_windows_doors",
      },
      {
        text: "Yes - for some windows, but no doors",
        value: "yes_some_windows_only",
      },
      {
        text: "Yes - for all doors, but no windows",
        value: "yes_all_doors_only",
      },
      {
        text: "No",
        value: "no",
      },
    ],
  },
  shutters_label_1: {
    step: 1,
    fieldType: "label_field",
    type: "desc",
    groupTag: "shutters_type_group",
    label: "If you have hurricane shutters, what type or types do you have? Select all that apply.",
    wrapperStyle: {
      class: "col s12 wm-label",
    },
    validations: {},
  },
  shutter_type_option: {
    step: 1,
    fieldType: "select_field",
    groupTag: "shutters_type_group",
    label: "",
    isMultiple: true,
    showLabel: false,
    helperText: "",
    browserDefault: false,
    showHelperText: false,
    value: null,
    wrapperStyle: {
      class: "col s12 wm-select-wrapper input-field",
    },
    fieldStyle: {
      class: "wm-select",
    },
    options: [
      {
        text: "Click to select",
        value: null,
        default: true,
      },
      {
        text: "Storm Panel (Aluminium or steel; attaches to the walls around your doors and windows; removable)",
        value: "storm_panel",
      },
      {
        text: "Automatic Roll Down (Polycarbonate or metal; attaches to the window, rolling down when needed and rolling up into a box when not in use; permanently secured to the window)",
        value: "automatic_roll_down",
        image: automatic_roll_down,
      },
      {
        text: "Accordion shutter ((Polycarbonate or metal; permanently attached to the window; folds up, accordion-style, when not in use)",
        value: "accordion",
        image: accordion,
      },
      {
        text: "Colonial shutter (Wood, metal or fiberglass; attaches to the sides of a window and can be folded up, giving the appearance of normal shutters when not in use)",
        value: "colonial",
        image: colonial,
      },
      {
        text: "Bahama shutter (Aluminium, wood or fiberglass; one louvered exterior shutter attached to the top of a window that is typically left open until a storm approaches).",
        value: "bahama",
        image: bahama,
      }

    ],
    validations: {},
  },
  exterior_door_material: {
    step: 1,
    fieldType: "group_field",
    tagId: "exterior_door",
    titleText: "Exterior Door Material",
    wrapperStyle: {
      class: "col s12 door-material",
      style: {
        marginTop: "",
      },
    },
    cardStyle: {
      class: "",
    },
    validations: {},
  },
  ed_label_1: {
    step: 1,
    fieldType: "label_field",
    type: "desc",
    groupTag: "exterior_door",
    label: "Select the most suitable option",
    wrapperStyle: {
      class: "col s12 wm-label",
    },
    validations: {},
  },
  exterior_door_option: {
    step: 1,
    fieldType: "select_field",
    groupTag: "exterior_door",
    label: "",
    isMultiple: true,
    titleText: "Door type",
    showLabel: false,
    helperText: "",
    browserDefault: false,
    showHelperText: false,
    value: null,
    wrapperStyle: {
      class: "col s12 wm-select-wrapper input-field",
    },
    fieldStyle: {
      class: "wm-select",
    },
    options: [
      {
        text: "Click to select",
        value: null,
        default: true,
      },
      {
        text: "Glass (regular)",
        value: "glass_regular",
      },
      {
        text: "Glass (impact resistant)",
        value: "glass_impact_resistant",
      },
      {
        text: "Wood (solid)",
        value: "wood_solid",
      },
      {
        text: "Wood (hollow)",
        value: "wood_hollow",
      },
      {
        text: "Metal (solid)",
        value: "metal_solid",
      },
      {
        text: "Metal (hollow)",
        value: "metal_hollow",
      },
      {
        text: "UPVC",
        value: "upvc",
      },
      {
        text: "Mixed - solid wood with regular glass",
        value: "mixed_solid_wood_with_regular_glass",
      },
      {
        text: "Mixed - solid wood with impact-resistant glass",
        value: "mixed_solid_wood_with_impact_resistant_glass",
      },
      {
        text: "Mixed - hollow wood with regular glass",
        value: "mixed_hollow_wood_with_regular_glass",
      },
      {
        text: "Mixed - hollow wood with impact-resistant glass",
        value: "mixed_hollow_wood_with_impact_resistant_glass",
      },
      {
        text: "Mixed - solid metal with regular glass",
        value: "mixed_solid_metal_with_regular_glass",
      },
      {
        text: "Mixed - solid metal with impact-resistant glass",
        value: "mixed_solid_metal_with_impact_resistant_glass",
      },
      {
        text: "Mixed - hollow metal with regular glass",
        value: "Mixed_hollow_metal_with_regular_glass",
      },
      {
        text: "Mixed - hollow metal with impact-resistant glass",
        value: "Mixed_hollow_metal_with_impact_resistant_glass",
      },
      {
        text: "Mixed - UPVC with regular glass",
        value: "mixed_upvc_with_regular_glass",
      },
      {
        text: "Mixed - UPVC with impact-resistant glass",
        value: "mixed_upcv_with_impact_resistant_glass",
      },
      {
        text: "Other (enter data) ",
        value: "other",
      },
    ],
    validations: {},
  },
  other_exterior_door_option: {
    step: 1,
    type: "text",
    groupTag: "exterior_door",
    fieldType: "input_field",
    placeholder: "Enter other value here",
    condition: {
      key: "exterior_door_option",
      value: "other",
      action: "hide",
    },
    validations: {},
  },
  porches_verandas: {
    step: 1,
    fieldType: "group_field",
    tagId: "porches_verandas",
    titleText: "Porches/verandas",
    wrapperStyle: {
      class: "col s12 wall-material",
      style: {
        /* marginTop: '', */
      },
    },
    cardStyle: {
      class: "",
    },
    validations: {},
  },
  ed_label_1: {
    step: 1,
    fieldType: "label_field",
    type: "desc",
    groupTag: "porches_verandas",
    label: "Select the most suitable options.",
    wrapperStyle: {
      class: "col s12 wm-label",
    },
    validations: {},
  },
  porches_verandas_select: {
    step: 1,
    fieldType: "select_field",
    // type: 'number',
    titleText: "Porches/verandas",
    groupTag: "porches_verandas",
    label: "",
    isMultiple: true,
    //disableIf: 'none',
    disableIf: ["none", "no-roof"],
    showLabel: false,
    helperText: "",
    selectGuide: true,
    browserDefault: false,
    showHelperText: false,
    value: null, // Sets default value
    // placeholder: '0',
    wrapperStyle: {
      class: "col s12 wm-select-wrapper input-field",
    },
    fieldStyle: {
      class: "wm-select",
    },
    options: [
      {
        text: "Click to select",
        value: "null",
        default: true,
      },
      {
        text: "Non-concrete porch/veranda roof detached from main house roof",
        value: "non_concrete_porch_veranda_roof_detached",
        image: non_concrete_porch_veranda_roof_detached,
      },
      {
        text: "Concrete porch/veranda roof detached from main house roof",
        value: "concrete_porch_veranda_roof_detached",
        image: concrete_porch_veranda_roof_detached,
      },
      {
        text: "Non-concrete porch/veranda roof attached to main house roof",
        value: "non_concrete_porch_veranda_roof_attached",
        image: non_concrete_porch_veranda_roof_attached,
      },
      {
        text: "Concrete porch/veranda roof attached to main house roof",
        value: "concrete_porch_veranda_roof_attached",
        image: concrete_porch_veranda_roof_attached,
      },
      {
        text: "Deck (no roof)",
        value: "no-roof",
        image: deck_no_roof,
      },
      {
        text: "None",
        value: "none",
      },

      /* 	{
        text: 'Porch/veranda with concrete roof',
        value: 'porch_veranda_with_concrete_roof'
      },
      {
        text: 'Porch/veranda with non-concrete roof',
        value: 'porch_veranda_with_non_concrete_roof'
      },
      {
        text: 'Deck (no roof)',
        value: 'deck_no_roof)'
      }, */
    ],
    validations: {},
  },
  garage_carport: {
    step: 1,
    fieldType: "group_field",
    tagId: "garage_carport",
    titleText: "Garage/carport",
    wrapperStyle: {
      class: "col s12 wall-material",
      style: {
        /* marginTop: '', */
      },
    },
    cardStyle: {
      class: "",
    },
    validations: {},
  },
  garage_carport_label_1: {
    step: 1,
    fieldType: "label_field",
    type: "desc",
    groupTag: "garage_carport",
    label: "Select the most suitable options.",
    wrapperStyle: {
      class: "col s12 wm-label",
    },
    validations: {},
  },
  garage_carport_select: {
    step: 1,
    fieldType: "select_field",
    titleText: "Garage/carport",
    // type: 'number',
    groupTag: "garage_carport",
    label: "",
    isMultiple: true,
    showLabel: false,
    helperText: "",
    selectGuide: true,
    disableIf: "none",
    browserDefault: false,
    showHelperText: false,
    value: null, // Sets default value
    // placeholder: '0',
    wrapperStyle: {
      class: "col s12 wm-select-wrapper input-field",
    },
    fieldStyle: {
      class: "wm-select",
    },

    options: [
      {
        text: "Click to select",
        value: null,
        default: true,
      },

      {
        text: "Fully enclosed and detached from main house with independent roof",
        value: "fully_enclosed_and_detached_from_main_house_with_independent_roof",
        image: fully_enclosed_and_detached_from_main_house_with_independent_roof,
      },
      {
        text: "Fully enclosed and attached to main house with connected roof system",
        value: "fully_enclosed_and_attached_to_main_house_with_connected_roof_system",
        image: fully_enclosed_and_attached_to_main_house_with_connected_roof_system,
      },
      {
        text: "Fully enclosed and attached to main house with independent roof",
        value: "fully_enclosed_and_attached_to_main_house_with_independent_roof",
        image: fully_enclosed_and_attached_to_main_house_with_independent_roof,
      },
      {
        text: "Open-sided and detached from main house with independent roof",
        value: "open_sided_and_detached_from_main_house_with_independent_roof",
        image: open_sided_and_detached_from_main_house_with_independent_roof,
      },
      {
        text: "Open-sided and attached to main house with independent roof",
        value: "open_sided_and_attached_to_main_house_with_independent_roof",
        image: open_sided_and_attached_to_main_house_with_independent_roof,
      },
      {
        text: "Open-sided and attached to main house with connected concrete roof system",
        value: "open_sided_and_attached_to_main_house_with_connected_concrete_roof_system",
        image: open_sided_and_attached_to_main_house_with_connected_concrete_roof_system,
      },
      {
        text: "Open-sided and attached to main house with connected non-concrete roof system",
        value: "open_sided_and_attached_to_main_house_with_connected_non_concrete_roof_system",
        image: open_sided_and_attached_to_main_house_with_connected_non_concrete_roof_system,
      },
      {
        text: "None",
        value: "none",
      },
    ],
    validations: {},
  },
  water_source_group: {
    step: 1,
    fieldType: "group_field",
    tagId: "water_source_group",
    titleText: "Main Water Source",
    wrapperStyle: {
      class: "col s12 water-material",
      style: {
        /*    marginTop: '24px', */
      },
    },
    cardStyle: {
      class: "",
    },
    validations: {},
  },
  waters_label_1: {
    step: 1,
    fieldType: "label_field",
    type: "desc",
    groupTag: "water_source_group",
    label: "Select the most suitable option.",
    wrapperStyle: {
      class: "col s12 wm-label",
    },
    validations: {},
  },
  water_source_option: {
    step: 1,
    fieldType: "select_field",
    // type: 'number',
    groupTag: "water_source_group",
    label: "",
    isMultiple: false,
    showLabel: false,
    helperText: "",
    browserDefault: true,
    showHelperText: false,
    value: null, // Sets default value
    // placeholder: '0',
    wrapperStyle: {
      class: "col s12 wm-select-wrapper input-field",
    },
    fieldStyle: {
      class: "wm-select",
    },
    options: [
      {
        text: "Click to select",
        value: null,
        default: true,
      },
      {
        text: "WASCO Supply",
        value: "wasco_supply",
      },
      {
        text: "Rainwater Harvesting System",
        value: "rain_water_harvesting",
      },
      {
        text: "Nearby standpipe",
        value: "nearby_standpipe",
      },
      {
        text: "Nearby well or spring",
        value: "private_well",
      },
      {
        text: "Nearby river",
        value: "nearby_river",
      },
    ],
    validations: {},
  },
};
